import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { api } from "../../../maps/data";
import EmptyList from "./EmptyList";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import {
  DataTableInfoData,
  ImagePreviewInfoData,
  InvAlertBox,
  LoaderStyled,
  VideoPreviewStyled,
  VideoPreviewWrapperStyled,
} from "./invCommonStyles";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import VideoPlayer from "../../camera/VideoPlayer";

const WrapperStyled = styled.div`
  display: grid;
  grid-gap: 15px;
  width: 900px;
`;

const SigWrapperStyled = styled.div`
  grid-gap: 15px;
  display: grid;
`;

const AlertsListStyled = styled.div``;

const SigBusket = () => {
  const [dashboardData, s_dashboardData] = useState([]);
  const [selected, s_selected] = useState([]);
  const [isLoading, s_loading] = useState(true);

  const getDashboardData = async () => {
    s_loading(true);
    api({
      type: "getSigmaBusketInventory",
      data: {},
    })
      .then((data) => {
        s_dashboardData(data);
        s_loading(false);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const sigmaHandle = async (productId) => {
    try {
      await api({
        type: "setSigmaBusketInventory",
        data: {
          productId,
          isWatching: false,
        },
      });
      await getDashboardData();
      s_selected([]);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  const isEmpty = dashboardData.length === 0;

  return (
    <WrapperStyled>
      {isLoading && (
        <LoaderStyled>
          <CircularProgress />
        </LoaderStyled>
      )}
      {!isLoading && isEmpty && (
        <EmptyList>
          In order to add items to watcher go to{" "}
          <Link to="/inventory-management">Inventory Management</Link>
        </EmptyList>
      )}
      {!isEmpty && !isLoading && (
        <SigWrapperStyled>
          <h3> Number of product: {dashboardData.length} </h3>

          {dashboardData.map((item, idx) => {
            const selectedItem = !!selected[idx];

            return (
              <Paper elevation={1} key={item._id}>
                <InvAlertBox style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                  <ImagePreviewInfoData>
                    <img
                      style={{ width: 90 }}
                      src={item?.product?.imageUrl}
                      alt=""
                    />
                  </ImagePreviewInfoData>
                  <DataTableInfoData>
                    <div>
                      <span className="label">Items:</span>
                      <span className="value">{item?.alerts?.length}</span>
                    </div>
                  </DataTableInfoData>
                  <div>
                    <Button
                      onClick={() => {
                        if (selectedItem) {
                          const temp = [...selected];
                          temp[idx] = undefined;
                          s_selected(temp);
                        } else {
                          const temp = [...selected];
                          temp[idx] = 1;
                          s_selected(temp);
                        }
                      }}
                    >
                      {selectedItem ? "Close alerts" : "See alerts"}
                    </Button>
                  </div>

                  <div>
                    <Button
                      color="error"
                      onClick={() => {
                        sigmaHandle(item.productId);
                      }}
                    >
                      Remove from Sigma
                    </Button>
                  </div>
                </InvAlertBox>
                {selectedItem && (
                  <AlertsListStyled>
                    {item?.alerts?.map((alert) => {
                      const cameras = alert?.data?.cameras || [];

                      return (
                        <VideoPreviewWrapperStyled key={alert._id}>
                          {cameras.map((cam) => {
                            return (
                              <VideoPreviewStyled key={cam.cameraId}>
                                <VideoPlayer videoSource={cam.imageUrl} />
                              </VideoPreviewStyled>
                            );
                          })}
                        </VideoPreviewWrapperStyled>
                      );
                    })}
                  </AlertsListStyled>
                )}
              </Paper>
            );
          })}
        </SigWrapperStyled>
      )}
    </WrapperStyled>
  );
};

export default SigBusket;
